import { INDIVIDUALS_ACTIONS } from 'constants/Actions/Individuals';

// Estado inicial del reducer
const aInitialState = {
    aIndividuals: [],
    nTotalPages: 0,

    oIndividual: null,
    nNewIndividualId: null,

    bIsError: false,
    bIsSuccess: false,

    aIndividualsSuggestion: [],
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a los individuos del sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const IndividualReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case INDIVIDUALS_ACTIONS.GET_ALL:
            return { ...aState, aIndividuals: oAction.data.data, nTotalPages: oAction.data.pages };
        case INDIVIDUALS_ACTIONS.GET_ACTIVE:
            return { ...aState, aIndividuals: oAction.data.data, nTotalPages: oAction.data.pages };
        case INDIVIDUALS_ACTIONS.FIND:
            return { ...aState, oIndividual: oAction.data };
        case INDIVIDUALS_ACTIONS.ADD:
            return { ...aState, nNewIndividualId: oAction.data };
        case INDIVIDUALS_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case INDIVIDUALS_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case INDIVIDUALS_ACTIONS.CLEAN:
            return { ...aState, bIsError: false, bIsSuccess: false, oIndividual: null };
        case INDIVIDUALS_ACTIONS.SUGGESTION:
            return { ...aState, aIndividualsSuggestion: oAction.data };
        case INDIVIDUALS_ACTIONS.SUGGESTION_CLEAN:
            return { ...aState, aIndividualsSuggestion: [] };
        default:
            return aState;
    }
}
